/* eslint-disable no-undef */


import React, { useEffect, useState } from 'react';
import utils from 'utils';
import { StepBody, OtpField, LabelError, Line, IconTiny, LabelCenter, ButtonLink, LabelTitle, IconSmall, Center, RowCenter } from 'meitav-uikit';
import { Parser } from 'html-to-react';

const { UmbracoUtills, rest } = utils;

const Otp = props => {
  const p = new Parser();

  useEffect(() => {
    // props.otpValue.setValue(111011);
    //props.setValueOTP(111111);
    //props.otpValue.setValue("111011");

    otpCredential();

  }, []);
  const otpCredential = () => {
    if ('OTPCredential' in window) {
      const ac = new AbortController();
      navigator.credentials
        .get({
          otp: { transport: ['sms'] },
          signal: ac.signal
        })
        .then(otp => {
          props.otpValue.setValue(otp.code);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
  useEffect(() => {
    if (props.otpValue.value != undefined && props.otpValue.value.length == 6) props.handleSubmitOtp();
  }
    , [props.otpValue.value]);


  const handleSendAgain = async e => {
    e.preventDefault();
    const otpGuid = localStorage.getItem('otpGuid');

    return new Promise(function (resolve, reject) {
      if (grecaptcha === undefined) {
        alert('Recaptcha non definito');
        reject();
      }
      grecaptcha.enterprise
        .execute(props.recapchaKey, {
          action: 'SendSmsAgain',
        })
        .then(function (token) {
          rest

            .get(`/api/manager/SendSmsAgain?otpGuid=${otpGuid}`, {
              headers: {
                gCaptcha: token,
                action: 'SendOtpAgain',
              },
            })
            .then(result => {
              if (result?.data) {
                props.setMessage(result?.data?.errorMessage);
                if (result?.data?.otpGuid !== '00000000-0000-0000-0000-000000000000') {
                  localStorage.setItem('otpGuid', result?.data?.otpGuid);
                  otpCredential();
                }


              }
            });
        });
    });
  };
  return (
    <>
      <StepBody>
        <RowCenter>
          <Line>
          <IconTiny src={`${import.meta.env.VITE_REACT_APP_IMAGE_URL ||
            window.location.origin}/${props.textIcon}`} />
</Line>
          <LabelTitle align='center' text={p.parse(props.textTitle)} />
          <LabelCenter text={props.subTitle} />
        </RowCenter>
        {!props.blocked ? <OtpField otpLength={6} {...props.otpValue} /> :
          null
        }
        <ButtonLink onClick={handleSendAgain}
          text={p.parse(props.textDescription)} />
        {props.message ? (<Center><LabelError text={p.parse(UmbracoUtills.getValueByKey(props.resourceError, props.message))} /></Center>) : (
          <></>
        )}
      </StepBody>

    </>
  );
}

export default Otp;
